import { create } from 'zustand';

type FulfillmentAnalyticsState = {
    isSuppressed: boolean;
    setSuppressed: (isSuppressed: boolean) => void;
};

export const useFulfillmentAnalyticsStore = create<FulfillmentAnalyticsState>()(set => ({
    isSuppressed: false,
    setSuppressed: isSuppressed => set({ isSuppressed }),
}));
